/**
 * Nomes das feature flags presentes no JSON `featureFlags` do payload JWT.
 * Mantenha sincronizado com o uso no código; novas flags devem ser adicionadas aqui.
 */
export const FEATURE_FLAGS = {
  /** Jornada de consignado CLT (rollout progressivo por % da base, via percentage rollout no GrowthBook). */
  CREDITO_CLT: 'feat_credito_clt',
  /** Campanha de Gift Card (controle = jornada padrão, tratamento = estímulos da campanha). */
  CAMPANHA_GIFT_CARD: 'feat_campanha_gift_card',
  /**
   * Acerto Prime: destaque + priorização da dívida Prime na Home (GrowthBook → JWT).
   * Variantes: `control` (desligado), `prime_padrao` (destaque com lista simples de outras
   * dívidas) e `prime_destaque` (destaque com accordion + logo do credor no header).
   */
  ACERTO_PRIME_V2: 'feat_acerto_prime_v2',
  /**
   * Ordenação de ofertas no seletor de pagamento do checkout pela prioridade configurada
   * por credor (controle = regra fixa atual: menor parcelamento/maior desconto em destaque).
   */
  PRIORIZACAO_OFERTAS_CHECKOUT: 'feat_priorizacao_ofertas_checkout',
  /**
   * Teste ABC de copy de urgência no checkout (`0` controle | `1` à vista | `2` parcelado).
   * Faixa de contagem regressiva e exit popup só nas variantes 1 e 2.
   */
  COPY_URGENCIA: 'feat_copy_urgencia',
  NOVO_GRID_DIVIDAS_DESKTOP: 'feat_novo_grid_dividas_desktop',
  /**
   * Fase 2 do "Seu Foco Agora" (BE-24781): sem parcela em foco, o bloco destaca a primeira dívida da
   * ordenação, com o botão que leva direto ao checkout.
   */
  SEU_FOCO_AGORA_DIVIDA: 'negociacao_home_seu_foco_agora_divida',
  /**
   * Login com uma única dívida disponível abre direto no checkout dela, com saudação e sem o botão
   * voltar, em vez da lista (controle = lista atual). Avaliado uma vez por login, após a sincronização.
   */
  CHECKOUT_UNICA_DIVIDA_DISPONIVEL: 'negociacao_checkout_unica_divida_disponivel',
} as const;

export type FeatureFlagName = (typeof FEATURE_FLAGS)[keyof typeof FEATURE_FLAGS];

/** Variantes do teste ABC `feat_copy_urgencia`. */
export const COPY_URGENCIA_VARIANTES = {
  CONTROLE: 0,
  A_VISTA: 1,
  PARCELADO: 2,
} as const;

export type CopyUrgenciaVariante = (typeof COPY_URGENCIA_VARIANTES)[keyof typeof COPY_URGENCIA_VARIANTES];
export type CopyUrgenciaTratamento = typeof COPY_URGENCIA_VARIANTES.A_VISTA | typeof COPY_URGENCIA_VARIANTES.PARCELADO;

/** Variantes do teste `feat_acerto_prime_v2`. */
export const ACERTO_PRIME_V2_VARIANTES = {
  CONTROL: 'control',
  PRIME_PADRAO: 'prime_padrao',
  PRIME_DESTAQUE: 'prime_destaque',
} as const;
